import { MaskedLines, Reveal } from "@/components/motion/Reveal";

/**
 * Scaled-down kinetic hero for inner pages — keeps the masked
 * line-by-line reveal, drops the heavy parallax.
 */
export default function PageHero({ overline, lines, sub, testid, titleTestid, children }) {
  return (
    <section
      data-testid={testid}
      className="relative bg-navy overflow-hidden border-b border-[#C6A87C]/15"
    >
      <div className="absolute inset-0 blueprint-grid-dark opacity-30 pointer-events-none" />
      <div className="absolute inset-0 noise-overlay opacity-10 pointer-events-none" />
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12 xl:px-24 pt-44 pb-16 lg:pt-56 lg:pb-24">
        {overline && (
          <Reveal y={14}>
            <div className="label-overline flex items-center gap-3">
              <span className="h-px w-10 bg-[#C6A87C]" />
              {overline}
            </div>
          </Reveal>
        )}
        <MaskedLines
          as="h1"
          lines={lines}
          delay={0.15}
          testid={titleTestid}
          className="mt-6 text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tighter text-[#F5F4F0] max-w-5xl font-medium"
        />
        {sub && (
          <Reveal delay={0.45} y={18}>
            <p className="mt-7 text-lg md:text-xl font-light text-[#8A99AA] leading-relaxed max-w-2xl">
              {sub}
            </p>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
